import React from "react";

const DashboardCard = (props) => {
  const cardStyle = {
    cursor: "pointer",
    textAlign: "center",
  };

  const cardNameStyle = {
    marginTop: 5,
    borderBottom: "1px solid #333",
  };

  if (!props.click) {
    cardStyle.cursor = "default";
  }

  return (
    <div className="DashboardCard" style={cardStyle} onClick={() => props.click && props.click()}>
      <div style={cardNameStyle}>{props.name}</div>
      {props.children}
    </div>
  );
};

export default DashboardCard;
